// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/frontend/stylesheets/breadcrumbs.sass
// module id = 196
// module chunks = 0